// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-spinner {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
#split-component {
  height: 100%;
}
#split-component .left-side {
  width: 100%;
  background-color: var(--primary-color);
}
#split-component .left-side .partner-powered {
  margin-bottom: 0.8rem;
}
@media (max-width: 768px) {
  #split-component .left-side .partner-powered {
    transform: none;
  }
}
#split-component .left-side .gyra-logo-background {
  position: absolute;
  max-height: 100vh;
  top: 0;
  right: 0;
}
@media (max-width: 768px) {
  #split-component .left-side .gyra-logo-background {
    max-width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
  }
}
#split-component .left-side .left-side-row {
  width: 100%;
  height: 100%;
}
#split-component .left-side .left-side-col {
  display: flex !important;
  flex-direction: column !important;
  width: 100%;
}
#split-component .left-side .left-side-wrapper {
  height: 100%;
  padding: 25px;
  display: flex;
  flex-direction: column;
}
#split-component .left-side .logo-container {
  width: 140px;
}
#split-component .left-side .logo-container .gyra-logo {
  width: 100%;
}
#split-component .left-side .partner-logo-wrapper {
  margin: auto;
}
#split-component .left-side .partner-logo {
  width: 400px;
}
@media (max-width: 768px) {
  #split-component .left-side .partner-logo {
    position: absolute;
    bottom: 1.4rem;
    width: 70%;
    left: 22px;
  }
}
#split-component .right-side {
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: white;
}
#split-component .right-side .copyright {
  position: absolute;
  bottom: 4rem;
  color: #c9d3cc;
  font-size: 0.95rem;
}
@media (max-width: 992px) {
  #split-component .left-side {
    height: 0;
  }
}
@media (max-width: 768px) {
  #split-component {
    display: inline;
  }
  #split-component .left-side {
    width: 100vw;
    height: 36vh;
    display: flex;
  }
  #split-component .left-side .logo-container {
    width: 120px;
    margin: 1.4rem 0 0 1.4rem;
  }
  #split-component .right-side {
    height: auto;
    width: 100vw;
  }
  #split-component .right-side .copyright {
    position: initial;
    bottom: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/others/LogInScreenWrapper/styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AACF;AAEA;EACE,YAAA;AAAF;AADA;EAII,WAAA;EACA,sCAAA;AAAJ;AALA;EAQM,qBAAA;AAAN;AAEM;EAAA;IACE,eAAA;EACN;AACF;AAbA;EAgBM,kBAAA;EACA,iBAAA;EACA,MAAA;EACA,QAAA;AAAN;AAEM;EAAA;IACE,gBAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;EACN;AACF;AA3BA;EA8BM,WAAA;EACA,YAAA;AAAN;AA/BA;EAmCM,wBAAA;EACA,iCAAA;EACA,WAAA;AADN;AApCA;EAyCM,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAFN;AA1CA;EAgDM,YAAA;AAHN;AA7CA;EAkDQ,WAAA;AAFR;AAhDA;EAuDM,YAAA;AAJN;AAnDA;EA2DM,YAAA;AALN;AAOM;EAAA;IACE,kBAAA;IACA,cAAA;IACA,UAAA;IACA,UAAA;EAJN;AACF;AA9DA;EAuEI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AANJ;AAtEA;EA+EM,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AANN;AAUE;EAAA;IAEI,SAAA;EARJ;AACF;AAWE;EAAA;IACE,eAAA;EARF;EAOA;IAII,YAAA;IACA,YAAA;IACA,aAAA;EARJ;EAEA;IASM,YAAA;IACA,yBAAA;EARN;EAFA;IAeI,YAAA;IACA,YAAA;EAVJ;EANA;IAmBM,iBAAA;IACA,YAAA;EAVN;AACF","sourcesContent":[".center-spinner {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n#split-component {\n  height: 100%;\n\n  .left-side {\n    width: 100%;\n    background-color: var(--primary-color);\n\n    .partner-powered {\n      margin-bottom: 0.8rem;\n\n      @media (max-width: @md-screen) {\n        transform: none;\n      }\n    }\n\n    .gyra-logo-background {\n      position: absolute;\n      max-height: 100vh;\n      top: 0;\n      right: 0;\n\n      @media (max-width: @md-screen) {\n        max-width: 100vw;\n        position: absolute;\n        top: 0;\n        left: 0;\n      }\n    }\n\n    .left-side-row {\n      width: 100%;\n      height: 100%;\n    }\n\n    .left-side-col {\n      display: flex !important;\n      flex-direction: column !important;\n      width: 100%;\n    }\n\n    .left-side-wrapper {\n      height: 100%;\n      padding: 25px;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .logo-container {\n      width: 140px;\n      .gyra-logo {\n        width: 100%;\n      }\n    }\n\n    .partner-logo-wrapper {\n      margin: auto;\n    }\n\n    .partner-logo {\n      width: 400px;\n\n      @media (max-width: @md-screen) {\n        position: absolute;\n        bottom: 1.4rem;\n        width: 70%;\n        left: 22px;\n      }\n    }\n  }\n\n  .right-side {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    justify-content: center;\n    align-items: center;\n    background-color: white;\n\n    .copyright {\n      position: absolute;\n      bottom: 4rem;\n      color: #c9d3cc;\n      font-size: 0.95rem;\n    }\n  }\n\n  @media (max-width: @lg-screen) {\n    .left-side {\n      height: 0;\n    }\n  }\n\n  @media (max-width: @md-screen) {\n    display: inline;\n\n    .left-side {\n      width: 100vw;\n      height: 36vh;\n      display: flex;\n\n      .logo-container {\n        width: 120px;\n        margin: 1.4rem 0 0 1.4rem;\n      }\n    }\n\n    .right-side {\n      height: auto;\n      width: 100vw;\n\n      .copyright {\n        position: initial;\n        bottom: 2rem;\n      }\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
